import { jsx as _jsx } from "react/jsx-runtime";
import s from './Card.module.css';
export function Card({ size, className, ...rest }) {
    return (_jsx("div", { ...rest, className: [s.card, size === 'sm' && s.sm, className].filter(Boolean).join(' ') }));
}
